import {
  AllocationRulesTemplateApi,
  CreateAllocationRuleTemplateDto,
  UpdateAllocationRuleTemplateDto,
  AllocationRuleTemplateDto,
} from '@storage/app/api'
import { AxiosPromise } from 'axios'

export class AllocationRuleTemplatesService {
  constructor(private api: AllocationRulesTemplateApi) {}

  async getAll(): Promise<Array<AllocationRuleTemplateDto>> {
    const { data: allocationRuleTemplates } = await this.api.allocationRulesTemplateGetAll()
    return allocationRuleTemplates
  }

  async create(
    createAllocationRuleTemplateDto: CreateAllocationRuleTemplateDto,
  ): Promise<AllocationRuleTemplateDto> {
    const { data: allocationRuleTemplate } = await this.api.allocationRulesTemplateCreate({
      createAllocationRuleTemplateDto,
    })
    return allocationRuleTemplate
  }

  async update(
    updateAllocationRuleTemplateDto: UpdateAllocationRuleTemplateDto,
  ): Promise<AllocationRuleTemplateDto> {
    const { data: allocationRuleTemplate } = await this.api.allocationRulesTemplateUpdate({
      updateAllocationRuleTemplateDto,
    })
    return allocationRuleTemplate
  }

  async delete(id: string) {
    await this.api.allocationRulesTemplateDelete({ id })
  }

  async isNameUnique(name: string, id?: string): AxiosPromise<boolean> {
    return await this.api.allocationRulesTemplateIsNameUnique({
      name,
      id,
    })
  }
}
